import { ThemeSettings } from '../../@types/ThemeSettings';

export const vedaLayoutPropertyToShopifyFieldId = (property: keyof ThemeSettings['layoutSettings']) => {
  return property;
};
